import {
  LiveChatChannel,
  LivechatConversationModel,
} from '../model/LivechatConversationModel';

export const identifyChannel = (remoteUserId: string): LiveChatChannel => {
  if (remoteUserId.startsWith('wc_')) {
    return 'webchat';
  }
  if (remoteUserId.startsWith('+')) {
    return 'sms';
  }
  if (remoteUserId.startsWith('ig_')) {
    return 'instagram';
  }
  if (remoteUserId.startsWith('em_')) {
    return 'email';
  }
  return 'facebook';
};

export const preferredConversationName = (convo: LivechatConversationModel) => {
  const generateName = convo => {
    if (convo.firstName && convo.lastName && convo.username) {
      if (
        convo.firstName === 'Instagram Contact' &&
        convo.lastName === 'IG' &&
        convo.username
      ) {
        return `@${convo.username}`;
      }
      return `${convo.firstName} ${convo.lastName} (@${convo.username})`;
    }
    if (convo.firstName && convo.lastName) {
      return `${convo.firstName} ${convo.lastName}`;
    }
    if (convo.firstName) {
      return `${convo.firstName}`;
    }
    if (convo.lastName) {
      return `${convo.lastName}`;
    }
    if (convo.username) {
      return `@${convo.username}`;
    }
  };
  if (
    identifyChannel(convo.remoteUserId) === 'facebook' ||
    !convo.linkedContacts?.length
  ) {
    return generateName(convo);
  }

  const fbContact = convo.linkedContacts.find(
    lc => identifyChannel(lc.remoteUserId) === 'facebook',
  );
  if (fbContact) {
    return generateName(convo);
  }

  const nonGuestContact = convo.linkedContacts.find(
    lc => lc.firstName !== 'Guest',
  );
  if (nonGuestContact) {
    return generateName(nonGuestContact);
  }
  return generateName(convo);
};
